import React from 'react';
import { useField } from 'react-final-form';

import { InputLabel, Stack } from '@mui/material';

import RawSliderInput from '../raw/RawSliderInput';

type Props = {
  label: string;
  iconLabel: JSX.Element;
  name: string;
  step?: number;
  marks?: boolean;
  units: string;
  min?: number;
  max?: number;
  defaultValue?: number;
};
export default function PropertySliderInput({
  defaultValue,
  name,
  label,
  iconLabel,
  step,
  marks,
  min,
  max,
  units,
}: Props) {
  const {
    input: { value, onChange },
  } = useField(name);

  return (
    <Stack spacing={1} alignItems="flex-start">
      <InputLabel shrink>{label}</InputLabel>
      <RawSliderInput
        label={iconLabel}
        value={value ?? defaultValue}
        onChange={onChange}
        units={units}
        step={step}
        marks={marks}
        min={min}
        max={max}
      />
    </Stack>
  );
}
